import axios from 'axios'

export default {
  getHelpByType: async function (type) {
    const url = 'ApplicationHelp/type/'
    const response = await axios.get(url + type, { crossdomain: true })
    return response.data
  },
}
